import React, { useState, useRef, useMemo } from "react";
import axios from "axios";
import "./quickRead.css";
import JoditEditor from "jodit-react";
import { useNavigate } from "react-router-dom";
import RichTextEditor from "react-rte";
import QuickReadPreview from "../popup/quickReadPreview/QuickReadPreview";

function QuickRead() {
  const navigate = useNavigate();

  const editor = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [disableLoginButton, setDisableLoginButton] = useState(false);

  const [name, setName] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [category, setCategory] = useState("");
  const [contentDesc, setContentDesc] = useState("");
  const [meta_desc, setMetaDesc] = useState("");
  const [desc, setDesc] = useState("");

  const [images, setImages] = useState(null);
  const [coverimage, setCoverImage] = useState(null);
  // const [images1, setImages1] = useState(null);
  const [previewModel, setPreviewModel] = useState(false);

  const [editorValue, setEditorValue] = useState(
    RichTextEditor.createEmptyValue()
  );

  const handleChange = (value) => {
    setEditorValue(value);
  };

  const handlePreviewClick = (e) => {
    e.preventDefault();
    setPreviewModel(true);
  };

  const config = useMemo(
    () => ({
      readonly: false,
      buttons: [
        "bold",
        "ol",
        "ul",
        "italic",
        "underline",
        "link",
        "unlink",
        "source",
      ],
    }),
    []
  );

  // const uploadImage = async ({ target }) => {
  //   setDisableLoginButton(true);
  //   handleNotificationError();
  //   const file = target.files;
  //   console.log("target",target)
  //   console.log("file", file);

  //   var formData = new FormData();
  //   for (let i = 0; i < file.length; i++) {
  //     formData.append("images", file[i]);
  //   }
  //   // console.log("formData",formData)
  //   // await axios
  //   //   .post(
  //   //     // `http://127.0.0.1:8000/magicFood/changeImageResolution/`,
  //   //     `https://qrs.btartisticyoga.com/magicFood/changeImageResolution/`,
  //   //     formData
  //   //   )
  //   //   .then((res) => {
  //   //     console.log("res", res);
  //   //     setImages(res.data.urlData);
  //   //     setDisableLoginButton(false);
  //   //   })
  //   //   .catch((err) => {
  //   //     console.log(err);
  //   //   });
  // };

  // const uploadImage = async ({ target }) => {
  //   setDisableLoginButton(true);
  //   handleNotificationError();
  //   const files = target.files;
  //   console.log("target", target);
  //   console.log("files", files);
  
  //   var formData = new FormData();
  //   for (let i = 0; i < files.length; i++) {
  //     const originalName = files[i].name;
  //     const modifiedName = modifyFileName(originalName);
  
  //     // Append the modified file with the new name to the FormData
  //     formData.append("images", new File([files[i]], modifiedName, { type: files[i].type }));
  //   }
  //       await axios
  //     .post(
  //       // `http://127.0.0.1:8000/magicFood/changeImageResolution/`,
  //       `https://qrs.btartisticyoga.com/magicFood/changeImageResolution/`,
  //       formData
  //     )
  //     .then((res) => {
  //       console.log("res", res);
  //       setImages(res.data.urlData);
  //       setDisableLoginButton(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  
  //   // Rest of your code to handle the formData as needed
  // };

  const uploadImage = async ({ target }) => {
    setDisableLoginButton(true);
    handleNotificationError();
    const files = target.files;
    console.log("files", files);

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
        const originalName = files[i].name;
        const modifiedName = originalName.includes("Slide") ? originalName : `Slide ${originalName}`;
        formData.append("images", new File([files[i]], modifiedName));
    }

    try {
        const response = await axios.post(
            "https://qrs.btartisticyoga.com/magicFood/changeImageResolution/",
            formData
        );

        console.log("response", response);
        setImages(response.data.urlData);
        setDisableLoginButton(false);
    } catch (error) {
        console.error(error);
    }
};

  
  function modifyFileName(originalName) {
    const fileExtension = originalName.split('.').pop();
    const fileNameWithoutExtension = originalName.replace(`.${fileExtension}`, '');
    const modifiedFileName = `Slide ${fileNameWithoutExtension}.${fileExtension}`;
    return modifiedFileName;
  }
  

  const uploadCoverImage = async ({ target }) => {
    setDisableLoginButton(true);
    handleNotificationError();
    const file = target.files;
    // const file = target.files[0];
    console.log("fileData111", file);

    var formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append("images", file[i]);
    }
    await axios
      .post(
        // `http://127.0.0.1:8000/magicFood/uploadImageToAWS/`,
        `https://qrs.btartisticyoga.com/magicFood/uploadImageToAWS/`,

        formData
      )
      .then((res) => {
        console.log("res", res.data.urls[0]);
        setCoverImage(res.data.urls[0]);
        setDisableLoginButton(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const notificationFunctionQuickRead = async (title, body, image, data) => {
    const response = await fetch(
      // "http://127.0.0.1:5001/btay-project-1551779459124/us-central1/AY/sendNotificationToUserQuickRead",
      "https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/sendNotificationToUserQuickRead",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: title,
          body: body,
          image: image,
          data,
        }),
        redirect: "follow",
      }
    )
      // return await response.json();
      .then((response) => response.json())
      .then((result) => {
        console.log("apiData", result.data);
        // return result.data;
      })
      .catch((error) => console.log("error", error));
  };

  // console.log("editorValue.toString", editorValue.toString("html"));
  const submitNewMagicFood = async (e) => {
    e.preventDefault();

    if (
      !name ||
      !subtitle ||
      !category ||
      !editorValue ||
      !coverimage ||
      !images ||
      !meta_desc
    ) {
      console.log("images", name, subtitle, category, editorValue, coverimage);
      setErrorMessage("Enter all details");
      return;
    }
    console.log("images", images);
    const obj = {
      name: name,
      imageAssets: images,
      subtitle: subtitle,
      category: category,
      desc: editorValue.toString("html"),
      thumbnail: coverimage,
      meta_desc:meta_desc
    };
    console.log("obj", obj);
    setDisableLoginButton(true);
    // await fetch("http://127.0.0.1:8000/magicFood/createQuickReads/", {
    await fetch("https://qrs.btartisticyoga.com/magicFood/createQuickReads/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("result", result);
        notificationFunctionQuickRead(
          "👉 New Life Hack!",
          obj.name,
          obj.thumbnail,
          obj
        );
        setName("");
        setImages(null);
        setCategory("");
        setSubtitle("");
        setCoverImage(null);
        alert("quickRead added successfully");
        setDisableLoginButton(false);
        navigate("/home");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleNotificationError = () => {
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  return (
    <>
      <div className="Apps">
        <div className="breadcrumbcontainer">
          <div className="breadcrumb-nav">
            <img src="/assets/rightchevron.png" alt="" />
            <span>Post Quick Read</span>
          </div>
        </div>

        <form className="quickread_from" onSubmit={submitNewMagicFood}>
          <div className="mb-3">
            <label htmlFor="Name" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              aria-describedby="name"
              value={name}
              onChange={(e) => {
                handleNotificationError();
                setName(e.target.value);
              }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="subtitle" className="form-label">
              Subtitle
            </label>
            <input
              type="text"
              className="form-control"
              id="subtitle"
              aria-describedby="subtitle"
              value={subtitle}
              onChange={(e) => {
                handleNotificationError();
                setSubtitle(e.target.value);
              }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="category" className="form-label">
              Category
            </label>
            <input
              type="text"
              className="form-control"
              id="category"
              aria-describedby="category"
              value={category}
              onChange={(e) => {
                handleNotificationError();
                setCategory(e.target.value);
              }}
            />
          </div>


          <div className="mb-3">
            <label htmlFor="category" className="form-label">
                Meta Description
            </label>
            <input
              type="text"
              className="form-control"
              id="meta_desc"
              aria-describedby="meta_desc"
              value={meta_desc}
              onChange={(e) => {
                handleNotificationError();
                setMetaDesc(e.target.value);
              }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="coverImage" className="form-label">
              Thumbnail Image
            </label>
            <input
              type="file"
              className="form-control"
              id="coverImage"
              aria-describedby="name"
              onChange={uploadCoverImage}
            />
          </div>
          <p
            style={{ marginBottom: "0rem", fontSize: "14px" }}
            className="Login_error"
          >
            Note: Thumbnail Image Size will be between 120KB to 200KB for more
            details of thumbnail image click below
          </p>
          <div style={{ marginBottom: "1rem" }}>
            <a
              target="_blank"
              href="https://btay-videos.s3.ap-southeast-1.amazonaws.com/quickRead_thumbnail/compress/Cover+(7)-min.jpg"
            >
              Click here
            </a>
          </div>

          <div className="mb-3">
            <label htmlFor="files" className="form-label">
              Images
            </label>
            <input
              type="file"
              className="form-control"
              id="files"
              aria-describedby="name"
              onChange={uploadImage}
              multiple
            />
          </div>

          <div className="mb-3">
            <label htmlFor="desc" className="form-label">
              Description
            </label>
            {/* <JoditEditor
              ref={editor}
              // value={contentDesc}
              config={config}
              // onBlur={handleUpdate}
              onChange={(newContent) => {
                handleNotificationError();
                setContentDesc(newContent);
              }}
            /> */}

            <RichTextEditor
            className="rich-text-editor"
            toolbarClassName="editor-toolbar"
            value={editorValue} onChange={handleChange} />
          </div>

          <p className="Login_error">{errorMessage}</p>

          {editorValue.toString("html") !== "<p><br></p>" && name && images && (
            <button
              className="quickRead__previewButton"
              onClick={handlePreviewClick}
            >
              Preview
            </button>
          )}

          <input
            disabled={disableLoginButton}
            className="submitBtn"
            type="submit"
            value="Submit"
          ></input>
        </form>

        <QuickReadPreview
          show={previewModel}
          onHide={() => setPreviewModel(false)}
          desc={editorValue.toString("html")}
          images={images}
          title={name}
          // name={program.name}
          // setPricingModal={setPricingModal}
        />
      </div>
    </>
  );
}

export default QuickRead;

// <p>If you’re feeling stressed out, or lethargic or depressed, there is an easy way to improve your condition immediately. While there are many ways to tackle your mental health issues, exercise is one of the best! Modern research has shown that exercise affects your brain and hormones (neurotransmitters) powerfully. When you combine focus and breathing, you get a powerful combination that has long term effects that are extremely positive for your mind. Let’s explore…</p>\r\n<ol>\r\n<li><strong>LONG NATURE WALKS</strong></li>\r\n<p>Walking is probably the most unappreciated form of exercise that we are now understanding more about. Walking in nature or ‘forest bathing’ can immediately help to reduce your anxiety levels. Combined with breathing fresh air and also inhaling the ‘good’ bacteria that is always present around trees, you get a boost of mood that makes you feel harmonious and happy.TIP: Try walking for a minimum of 50 min or aim for 10,000 steps for maximum benefits.</p>\r\n<li><strong>YOGA</strong></li>\r\n<p>Obviously, Yoga is the natural choice to beat stress and anxiety but don’t be worried if you sometimes feel worse immediately after a yoga class. Yoga is a powerful science that works on the root cause of your stress, and for that reason you may feel the benefits a bit later on. Be patient and you may see miraculous changes that you never thought was possible. This is the power of Yoga!</p>\r\n<li><strong>SWIMMING</strong></li>\r\n<p>It takes effort to find a swimming pool and be disciplined enough to swim on a regular basis, but the benefits to your mind are incredible. Water is a known healer to our body and especially during the summer, you owe it to yourself to spend as much time near the ocean and soak in the sand, sun and sea water – all three of which are extremely good for your mental health. The fact that you also improve your cardio vascular endurance is a double bonus!</p>\r\n<li><strong>DANCING</strong></li>\r\n<p>Yes, for those exercise haters, there is a great way to get your blood pumping, breathe more and also release your stress at the same time. Sign up for a dance class! It’s a great way to move, meet new people and also improve your mind-body coordination. If you aren’t a social person, then simply put on music in your room and dance alone. But this is easier than it looks. Just decide and do it!</p>\r\n<li><strong>RESISTANCE TRAINING</strong></li>\r\n<p>A lot of people go to the gym to build their body or develop a six pack. But many of them train their muscles to beat stress and just feel better. Life always rewards hard work in some way or another, so if you can manage to put in at least 2-4 hours or resistance training, it will do wonders for your physical health and your mood. Don’t forget: It’s not about becoming bigger or showing off. It’s about becoming stronger and being able to do things that you could do even when you were younger. It’s freedom. And more freedom always puts you in a better mood!</p>

// https://btay-videos.s3.ap-southeast-1.amazonaws.com/quickRead_thumbnail/compress/Cover+(6)-min.jpg

// =============================================================================
// 11
// 4 REASONS TO USE COCONUT OIL IN YOUR DAILY LIFE
//  <p>Coconut oil is extracted from the flesh of the mature coconuts harvested from the coconut palm. There are many benefits in including it in your daily life which enhances our health and wellbeing.</p>\r\n<ol>\r\n<li><strong>GREAT FOR WEIGHTLOSS</strong></li>\r\n<p>A No-Cholesterol high energy nutritional bonanza that does not get stored in the body as fat but is transformed into 100 percent energy. Being rich in MCT’s ( medium chain fatty acids) It is so easily absorbed by the body that it is one of the strongest allies of the digestive system. It helps in limiting the appetite and provides satiety after your meals. This cuts cravings and the need to overeat.</p>\r\n<li><strong>IMMUNITY BOOSTER</strong></li>\r\n<p>Coconut oil contains two essential ingredients that contribute to an immunity boost. These are the anti-viral lauric acid and caprylic acid. These acids can fight off bacteria and viruses that can cause harmful diseases.</p>\r\n<li><strong>GOOD FOR SKIN AND HAIR</strong></li>\r\n<p>coconut oil works as a great sunscreen that blocks UV rays yet allows body to create vitamin D. It also doubles as a good moisturiser keeping the skin moist and healthy. When used for the hair, it repairs hair damage and gives shiny hair.</p>\r\n<li><strong>MULTIPLE HEALTH BENEFITS</strong></li>\r\n<p>use of coconut oil in oil pulling reduces bad breath and bacteria in the mouth. Coconut oil is known to stabilise blood sugar levels in the body. It is also a rich antioxidant and reduces inflammations in the body when used regularly.</p>

// =============================================================================

// ===============================
// 12
// 5 REASONS TO ADD CORIANDER TO YOUR DIET
//  <p>Coriander is also known as Chinese parsley, dhania or cilantro. All parts of the plant are edible, but the fresh leaves and the dried seeds are the parts most traditionally used in cooking. Though the leaf and the seed come from the same plant, they have different nutrient profiles.<br/>Cilantro coriander leaf has higher levels of vitamins, such as vitamins A, K and E, while the the seed is more abundant in minerals like Manganese, Iron, Magnesium and Calcium. The different properties of coriander leaves and seeds have led people to use them differently in recipes. The refreshing, citrusy taste of coriander leaves is mostly added just before serving as heat can reduce its flavor. In contrast, the coriander seed has a more warm and spicy taste, hence is more commonly used in curries, rice dishes and soups. Either way, make sure you add this potent herb to your cooking in some way! Here are five reasons!</p>\r\n<ol>\r\n<li><strong>CAN REDUCE INFLAMMATION</strong></li>\r\n<p>Both coriander leaf and seed are packed with molecules called antioxidants. Antioxidants helps to reduce inflammation in the body by binding to and suppressing inflammation-promoting molecules known as free radicals. Furthermore, antioxidants in a coriander seed extract can reduce inflammation and inhibit the growth of cancer cells.</p>\r\n<li><strong>CAN REDUCE RISK FACTORS FOR HEART DISEASE</strong></li>\r\n<p>Coriander seed extracts has properties that may reduce blood clotting and significantly reduces blood pressure by acting as a diuretic, thus eliminating water and salt from your body. Overall, coriander reduces the risk of heart disease.</p>\r\n<li><strong>CAN LOWER BLOOD SUGAR LEVELS</strong></li>\r\n<p>Both coriander leaves and seeds may help reduce blood sugar levels. It was found that the extracts from coriander seeds have certain compounds that when discharged into the blood caused anti hyperglycemic, that mimics insulin movement and controls the blood glucose levels.</p>\r\n<li><strong>CAN HELP FIGHT INFECTIONS</strong></li>\r\n<p>The antimicrobial and antibacterial properties of both coriander leaves and seeds can help fight infections. Certain properties in fresh coriander leaves helps to fight food-borne infections by killing bacteria such as Salmonella. Water from boiled coriander seed helps with infections of the urinary tract.</p>\r\n<li><strong>CAN IMPROVE SUN DAMAGED SKIN</strong></li>\r\n<p>Coriander is full of vitamin A, and helps with hydrating the skin. Also, it slows down ageing process. Coriander seed water can help with reducing skin conditions such as eczema, psoriasis and pigmentation.</p>
// ===============================

// ===============================
// 13
// 5 REASONS TO INCLUDE MORINGA IN YOUR FOOD!
//  <p>Moringa, also popularly known as drumsticks has been a part of the Indian diet since forever. It is only recently that the astounding benefits of every part of this tree have been rediscovered. Moringa, whose benefits were well known in the traditional medicines, is unbeatable when it comes to its nutritional content. Every inch of the tree is just loaded with all the nutrients required by the body. You will be very surprised to know that it has more proteins than milk, more vitamin C than oranges and more potassium than a banana! When we say moringa, it can be the leaves, the unripe seeds in the pods that are delicious when cooked or even the flowers. All are very nutritious. But the leaves excel in their antioxidant, vitamin, mineral and protein content except for vitamin C, which the unripe seeds in the pods are loaded with. The seeds when they are fully ripe are rich sources of poly-unsaturated fatty acids, which are also extremely good for health.</p>\r\n<p><br />Here are FIVE massive reasons to include it in your diet: </p>\r\n<ol>\r\n<li><strong>IT BALANCES BLOOD PRESSURE</strong></li>\r\n<p>Quercetin, a powerful antioxidant in moringa acts powerfully to lower cholesterol and prevents the formation of plaque. Isothiocyanates which are plant-based chemicals are excellent anti-inflammatory compounds. They prevent the arteries from hardening and they are found in plenitude in moringa. The presence of high amounts of Magnesium and Potassium (Magnesium being as high as 40% of daily requirements) in moringa, relaxes the blood vessels, ensuring smooth flow of blood, thus helping keep the blood pressure balanced.</p>\r\n<li><strong>CAN LOWER BLOOD SUGAR LEVELS</strong></li>\r\n<p>Moringa works magically for diabetics, helping in case of both Type 1 and Type 2. The isothiocyanates, antioxidants present in moringa repair the beta cells which are the insulin-producing cells in the pancreas. This stimulates the production of insulin to bring down the blood sugar levels. Chlorogenic acid, another antioxidant in moringa, improves sugar metabolism and lowers blood sugar levels.</p>\r\n<li><strong>CAN BALANCE YOUR HORMONES </strong></li>\r\n<p>There are 9 essential amino acids that a human body needs as building blocks of proteins. They can only be obtained from food and moringa contains all of them. Furthermore, proteins are essential for formation of our entire body, as well as the brain cells. The transmission in the brain takes place with the help of proteins, as the neurotransmitters are made of proteins. Adding moringa to the diet improves all brain functions and it helps improve mood, as it supports sufficient production of happy hormones like serotonin and dopamine. Moringa leaves are also rich in Iron and contain 30% of the daily requirement.</p>\r\n<li><strong>RICH IN ANTIOXIDANTS</strong></li>\r\n<p>Anti-oxidants fight the free radicals in our body. By doing so they curtail the buildup of oxidative stress which if not deal with can turn into cardiac disease and type 2 diabetes. Moringa has most of the antioxidants, like tannin, saponin and phenolic compounds that balance out the oxidation damages in the body, reduce inflammation, lower LDL and increase HDL.</p>\r\n<li><strong>MAY REDUCE INFLAMMATION</strong></li>\r\n<p>Long term inflammation can lead to chronic health problems such as heart disease and cancer. Moringa has anti-inflammatory properties. Isothiocyanates are the main anti-inflammatory compounds found in moringa leaves, pods and seeds. Few ways to incorporate moringa into our diet is to cook the tender drum sticks like a vegetable. Alternatively, one can dry the leaves and make a powder of it so it can be added to smoothies, oats and soups. Either way make sure you include this amazing super-food in your diet!</p>

// ===============================

// ===============================
// 14
// 5 WAYS TO ADD PLANT BASED PROTEIN IN YOUR DIET!
// <p>Plant based protein are an important source of essential amino acids, which are building blocks of protein that our bodies cannot produce on their own. Eating a plant based diet that is rich in protein has been linked to several health benefits, including a lowering he risk of heart disease, diabetes and various types of cancers.</p>\r\n<p><br />This is due part to the fact plant based diets are generally high in fiber and antioxidants that an lower inflammation and support health immune functions. Plant based diets also improves gut health by promoting healthy gut micro-biome. The fiber content in vegetables can lower blood pressure and cholesterol levels, leading to a healthy heart.</p>\r\n<p><br />Here are five vegetables with high protein content than can be added to your diet: </p>\r\n<ol>\r\n<li><strong>EDAMAME</strong></li>\r\n<p>Edamame is a type of soybean that is harvested when it is still young and green. It is a good source of plant-based protein, with around 18.5 grams of protein per 100 grams. Edamame is also a good source of fiber and various vitamins and minerals.</p>\r\n<li><strong>LENTILS</strong></li>\r\n<p>Lentils are a type of legume that is high in protein, with around 9 grams of protein per 100 grams. They are also a good source of fiber, iron, and various other nutrients.</p>\r\n<li><strong>CHICKPEAS </strong></li>\r\n<p>Chickpeas, also known as garbanzo beans, are another type of legume that is high in protein, with around 8 grams of protein per 100 grams. They are also a good source of fiber, iron, and various other nutrients.</p>\r\n<li><strong>SPINACH</strong></li>\r\n<p>Spinach is a leafy green vegetable that is relatively high in protein, with around 2.9 grams of protein per 100 grams. It is also a good source of iron, calcium, and various vitamins and minerals.</p>\r\n<li><strong>BROCCOLI</strong></li>\r\n<p>Broccoli is a cruciferous vegetable that is relatively high in protein, with around 2.8 grams of protein per 100 grams. It is also a good source of fiber, vitamin C, and various other nutrients.</p>

// ===============================

// ===============================
// 15
// 6 FOODS FOR SOUND AND RESTFUL SLEEP!
// <p>It’s only in deep sleep that your body works to maintain a healthy brain and to keep your physical body in a healthy condition. In children, sleep helps in their growth and development. Good sleep also keeps your emotions in check and helps to balance your moods. Inadequate sleep over time can raise your risk of long term chronic illnesses. Our daily intake of food and nutrients can help to improve our quality of sleep.</p>\r\n<p><br />Here are 6 foods to eat to improve your sleep:</p>\r\n<ol>\r\n<li><strong> KIWI</strong></li>\r\n<p>The Kiwi fruit has many vitamins and nutrients, out of which most prominent are vitamin C, vitamin E, potassium and folate. Kiwis are also rich in serotonin and antioxidants which help with sound sleep. Folate in the kiwi fruit also helps the brain the produce sleep inducing chemicles such and serotonin and dopamine. Try eating one or two kiwi fruits one hour before bed time for sound sleep.</p>\r\n<li><strong>TURMERIC MILK</strong></li>\r\n<p>A glass of warm turmeric milk can reduce the restlessness during sleep and improve quality of deep sleep. An added benefit is the antioxidants in turmeric heals the body of internal injuries and reduces inflammation.</p>\r\n<li><strong>NUTS  </strong></li>\r\n<p>Nuts such as walnuts, almonds, pistachios and cashews contain melatonin and essential minerals like magnesium and zinc. Melatonin acts on receptors in your body to encourage sleep. Magnesium activates the parasympathetic nervous and helps your body and muscles to relax which leads to a relaxed and sound sleep. Zinc has a calming effect on your central nervous system, which enhances good sleep. Do have a handful of nuts daily.</p>\r\n<li><strong>CHAMOMILE TEA</strong></li>\r\n<p>Chamomile tea unlike other varieties of teas is rich in a specific antioxidant called apigenin, which binds to certain receptors in your brain that may promote sleepiness and reduce insomnia. Chamomile tea is also rich in flavones which reduce inflammation that can lead to chronic diseases such as cancer and heart disease. A cup before you sleep can calm you down.</p>\r\n<li><strong>PASSION FLOWER TEA</strong></li>\r\n<p>A rich source of flavonoid antioxidants, which are known for their role in reducing inflammation, boosting immunity and reducing risk of heart disease. Additionally passion flower teas is also know to reduce anxiety. The antioxidant apigenin produces a calming effect by binding certain receptors in your brain. Passion-fruit flower teas also increases production of gamma and GABA. GABA inhibits other brain chemicals that induce stress, such as glutamate. Passionflower tea has many calming properties that can promote sleep hence it would be beneficial to drink it before going to bed.</p>\r\n<li><strong> WHITE RICE</strong></li>\r\n<p> Even though White rice is stripped off from most of it’s fibre and vitamins, it still has a few beneficial nutrients such as folate, thiamine and manganese. It’s high content of carbohydrates and lack of fiber, contributes to its high glycemic index (GI). As carbohydrates gets converted to glucose, glucose requires insulin. As insulin increases, it causes melatonin and serotonin to increase too, which in turn calms you down and cause s drowsiness. Eating food with high glycemic index 1 hour before bed time can improve sleep quality. However it is best to consume white rice moderately.</p>\r\n<p><br/>It is also important to note that there are certain food that inhibit your quality of sleep. Alcohol, caffeinated drinks, sugar, chocolates and spicy food should be avoided before sleep.</p>

// ===============================

// ===============================
// 20
// 6 FOODS FOR SOUND AND RESTFUL SLEEP!
// <p>Lentils are specific kinds of pulses which are basically legumes or plants with seeds in protective pods. They are mostly round shaped and some take the shape of a heart, too. They can be found whole or split - both versions are equally nutritious. They are commonly seen in red, yellow, brown, green and black. This powerful protein-rich, lens- shaped bean is also known as Dal in India and as pulse in other parts of the world.</p>\r\n<p><br/>Though lentils have been popular throughout history, it is also a staple home-cooked food. Especially if you are a vegan or a vegetarian, lentils are the biggest source of protein in your diet. They also come with many other health benefits. Let’s name a few!</p>\r\n<ol>\r\n<li><strong>RICH IN PERFECT PROTEIN</strong></li>\r\n<p>One cup of lentils has 18 grams of protein. Thant’s an incredible source of protein for vegetarians and vegans. A cup of lentils has 36% of daily protein value (DV). Lentils are a rich source of protein, which is of good quality. There are 9 essential amino-acids that need to come from our diet. They are histidine, isoleucine, leucine, lysine, methionine, phenylalanine, threonine, tryptophan and valine. Only when all 9 amino acids are present, that food can be considered a complete protein. Lentils are just short of one amino-acid to fulfil this requirement - methionine. This is easily overcome by combining lentils with a cereal which has high amounts of methionine, such as rice or wheat.</p>\r\n<p><br />One may wander - Why do we need proteins? Proteins are the basic building blocks of life. Almost 16% of our body is made up of protein. We need proteins for the functioning of every single cell in our body. Low proteins can lower the activity of the body, keeping you tired, low in energy, mentally dull, lethargic and even sad. So, start having this amazing source of protein every day!</p>\r\n<li><strong>REDUCES CHOLESTEROL</strong></li>\r\n<p>A low fat but high fibre content is what makes lentils great to lower cholesterol. A cup of cooked lentils has about 15 grams or almost 63% DV of fibre, which is really high. Fiber slows down the absorption of cholesterol into the blood stream, and lowers the formation of LDL or bad cholesterol. This increases the level of HDL or good cholesterol. Higher amounts of HDL prevent blockages in the arteries, reducing the risk of heart problems.</p>\r\n<li><strong>CONTROLS DIABETES</strong></li>\r\n<p>Most of the high amounts of fibre in lentils is in the form of resistant starch, which is a type of sugar that is resistant to digestion. This moves slowly along the intestines and slows down the release of sugars into the blood stream, lowering blood sugar levels. This slow release of sugars into the blood stream also keeps the sugar supply steady for long, balancing blood sugar levels, making lentils the ideal food for diabetics.</p>\r\n<li><strong>HEALTHY HEART </strong></li>\r\n<p>A cup of lentils has 90% DV of folate, 37% DV of Iron and 25% DV of Copper. While folate and Copper are very essential for the formation of red blood cells, Iron is very important for haemoglobin, which is a oxygen-carrier. So, lentils can boost the circulation of oxygen-rich blood, preventing the formation of blocks in the arteries and heart diseases. Lentils are also loaded with Potassium, which is available about 27% DV in one cup. Potassium plays multiple key roles, starting from triggering the heart beats to transporting blood to every part of the body. Potassium also relaxes the walls of the blood vessels, making the blood flow smoother, thus reducing blood pressure.</p>\r\n<li><strong>BALANCES THE IMMUNE SYSTEM</strong></li>\r\n<p>Lentils contain high amounts of vitamin B6 - as much as 18% of DV in one cup. This vitamin also increases the levels of the neurotransmitter serotonin, the happy hormone. High level of serotonin balances the immune system. Lentils are also rich in antioxidants carotenoids, phenolic compounds and flavonoids, all of which work on reducing the free radical load on the body. This eases the functioning of immunity cells, keeping them healthy, helping us maintain good immunity.</p>\r\n<li><strong>CAN PREVENT CANCER </strong></li>\r\n<p> Lentils have a kind of protein called Lectin, which along with the abundance of polyphenols and selenium kill the cancer cells and prevent the tumor from spreading. Lentils are particularly effective in preventing colon, prostrate and breast cancers.</p>

// ===============================

// ===============================
// 21
// 6 REASONS TO INCLUDE MANGO IN YOUR DIET THIS SUMMER!
// <p>Its not called the king of fruits just for its rich look, fragrance and taste, but also for its grand nutritional content. Just 200 grams of mangoes contain all the Vitamin C one needs in a day. Rich in Folate, mangoes have a wide spectrum of nutrients, vitamins B, E, K, minerals, calcium, iron, magnesium, manganese, potassium, phosphorus and zinc.</p>\r\n <p><br />They are treasure troves of an array of antioxidants, like beta carotene, from which mangoes derive their rich golden hue, flavonoids like Mangiferin, which is unique to mangoes, from which they derive their name, tannins and flavonoids; all of which give mangoes their kingly status. Let’s see how!</p>\r\n<ol>\r\n<li><strong>STOMACH CLEANSER</strong></li>\r\n<p>The fiber Pectin makes Mangoes great for digestion and for relieving constipation, cleansing the intestines and colon; antioxidants and vitamin C, protect the digestive system against inflammation, neutralize acidity and increase good bacteria.</p>\r\n<li><strong>FOR A HEALTHY HEART </strong></li>\r\n<p>Mangiferin, the flavonoid unique to mangoes, fights against chronic inflammation, protecting the arteries from thickening. High amounts of fibers, lower LDL and increase HDL, protecting against the formation of plaque and keep the blood pressure under control, thus safeguarding the heart.</p>\r\n<li><strong> HIGH NUTRIENT VALUE</strong></li>\r\n<p>Mangoes are high in natural sugars, which are a rich and stable source of energy. This, in combination with good amounts of copper, improve the production of red blood cells, vitamin C, which enhances iron absorption in the body, and folate which increases the level of hemoglobin, make mangoes very nourishing and energizing. They boost immunity levels, and keep diseases at bay.</p>\r\n<li><strong>HYDRATING</strong></li>\r\n<p>Summer is equal to mangoes in tropical countries. Being a summer fruit, nature has filled mangoes with more than 80% water, making them perfect thirst quenchers and heat stroke guards. Yet certain ingredients in mangoes make them hot in nature which leads to acne et cetera. Pre-monsoon showers do reduce the heaty nature of mangoes.A great tip that works wonders is soaking them in water, for at least half an hour to quench the heat out.</p>\r\n<li><strong>RICH IN VITAMIN A</strong></li>\r\n<p>Beta carotene the color pigment in mangoes gets converted to vitamin A in the body which is great for eye health, preventing degeneration of eyes with age and the damaging effects of the rays of blue light.</p>\r\n<li><strong>AID IN WEIGHT LOSS </strong></li>\r\n<p>Mangoes are a complete meal. Their capacity to increase the good bacteria in the stomach, aiding better digestion, and slow the release of sugars into the bloodstream, keeps you satiated for longer, curbing binge eating.</p>\r\n<p><br/>Mangoes contain tartaric acid and maleic acid, which give them their sourness. They prevent acidity and thus obesity caused due to insulin resistance.</p>

// ===============================

// This mango season keep fit while you dip yourself in the deliciousness of the mango fruit devoured to your heart’s content.
// \r\n
// \r\n
// THE GREAT HEALTH BESTOWER
// \r\n
// Mangoes are a great pre-workout snack. Being loaded with potassium, they help in alleviating pain from sore muscles and aid in electrolyte balance of the body.

// \r\n
// AIDS GOOD SLEEP
// \r\n
// Rich in vitamin B6, mangoes aid in melatonin production( a hormone required to induce sleep). Mangoes when had at night before bedtime can improve your sleep quality and help you fall asleep faster.

// \r\n
// SATIATES YOUR CRAVINGS
// \r\n
// Mangoes are naturally sweet fruits and can help in satisfying sweet cravings without really piling up on your calories. Having a mango a day can naturally reduce you sugar craving yet uplift your mood without causing any health damage.

// \r\n
// Anaemia is a condition that currently affects 25% of the human population. It occurs when the body does not produce enough red blood cells. These cells are the transporters that carry oxygen throughout the body and their deficiency may lead to anaemia.

// \r\n

// In this situation, when there is a decrease of oxygen supply to the body’s tissues one may experience tiredness, weakness, shortness of breath, dizziness or headaches. Red blood cells or RBCs require Iron, vitamin B12, folate, and other nutrients in order to be healthy and in top form.

// \r\n

// Here are 7 foods that will boost your RBC count enriching your blood:

// \r\n
// \r\n
// SPINACH
// \r\n
// A handful of spinach can give you 15% of your daily requirement of Iron. It also has vitamin C which works as an aid for Iron absorption.

// \r\n
// RED KIDNEY BEANS
// \r\n
// All beans help bone marrow to produce red blood cells. Red kidney beans have the highest content of Iron amongst all beans. they have more than 30% of the required daily intake.

// \r\n
// DARK CHOCOLATE, 85%
// \r\n
// It is packed with minerals including Iron, Magnesium, Zinc, Copper and phosphorus, which also helps with better immunity and sleep quality.

// \r\n
// QUINOA
// \r\n
// It is a great gluten-free grain that is a rich source of Iron. It is also very high in protein, folate, Magnesium, Copper and many other nutrients.

// \r\n
// TOFU
// \r\n
// Tofu provides 19% of DV for Iron per serving. It is also rich in protein and minerals. Its isoflavones may improve heart health.

// LEGUMES
// \r\n
// Legumes like beans, peas and lentils are rich in Iron. They also contain protein, fibre, folate and manganese that will aid weight-loss.

// BROCCOLI
// \r\n
// It is incredibly nutritious. A serving of one cup has 6% of DV and loads of vitamin C. Note: Iron is best absorbed on an empty stomach and is enhanced by taking it with vitamin C-rich foods.

// LEGUMES
// \r\n
// Legumes like beans, peas and lentils are rich in Iron. They also contain protein, fibre, folate and manganese that will aid weight-loss.

// \r\n

// Note: Avoid drinking tea and coffee especially before or after an Iron-rich meal as they can act as inhibitors and hamper the absorption of Iron into the blood stream.

// Cardamom is a spice that comes in tiny seed-form and grows in a small pod. This spice has a complex flavor which has the ability to enhance both savory and sweet dishes. Cardamom can be powdered or used crushed in the pod itself. The benefits of the spice reside in the oil when the tiny black seeds get crushed. There are 2 main varieties of cardamom - green and black. Green variety being more potent in flavor, than the black.

// \r\n

// 6 REASONS WHY YOU SHOULD INCLUDE CARDAMOM in YOUR DIET:

// \r\n
// \r\n
// ANTIMICROBIAL PROPERTIES
// \r\n
// The essential oil of the cardamom has both antibacterial and anti-fungal properties, making it a powerful natural antibiotic.

// \r\n
// AIDS DIGESTION
// \r\n
// Cardamom stimulates the digestive juices. It has the essential oil menthone that helps in alleviating gastrointestinal problems like clearing stomach ulcers and acid reflux.

// \r\n
// CAN LOWER BLOOD PRESSURE
// \r\n
// The high level of antioxidants found in cardamom can fight the free radicals and reduce blood pressure and keep your heart healthy. Also, cardamom has diuretic properties that can flush out excess water around the heart and help in reducing blood pressure.

// \r\n
// CAN TREAT BAD BREATH AND GUM DISEASE
// \r\n
// Chewing a pod of cardamom after a meal can not only improve your digestion, but can also improve your oral health. It has properties to fight common mouth bacteria thus keeping your breath fresh and teeth cavities-free.

// \r\n
// CAN LOWER BLOOD SUGAR LEVELS
// \r\n
// The antioxidants, anti-inflammatory and hypolipidemic properties in cardamom can help control blood sugar levels

// CAN IMPROVE LIVER HEALTH
// \r\n
// Cardamom extract may decrease elevated levels of liver enzymes, triglycerides and cholesterol. It may also prevent liver enlargement and reduce risk of fatty liver disease.

// \r\n

// TIP – Few ways to include cardamom in your diet is to chew a pod after a meal, have cardamom tea or include it in deserts or cooked dishes / curries.

// Hormones are chemicals secreted by certain glands or organs in our body. As they enter the bloodstream they influence certain cells in the body and their main function in general is to maintain a balance in the body called body homeostasis. They also induce changes like growth in children and development of sexual features during puberty. As some of these hormones dwindle with age, they bring about other changes, like gradual disintegration of the body. Hormones in general form a complex network in the body - they are all connected to each other. So, an imbalance in one of the hormones can lead to an imbalance in the entire endocrine (hormonal) system. Luckily, a hormonal imbalance can be set right with the right food and a yoga practice.

// \r\n

// Here are 6 excellent foods to help balance your hormones:

// \r\n
// \r\n
// WHEATGRASS
// \r\n
// Wheatgrass is a miracle food that cannot be defeated in its nutritional as well as medicinal qualities. Wheatgrass is incredibly rich in the antioxidant green pigment chlorophyll. Chlorophyll increases the hemoglobin and oxygen levels in the body. Increased oxygen levels flushes out toxins, bringing a balance in the hormones. Just a teaspoon of wheatgrass powder has vitamin E, an unbelievable amount of Manganese and good amounts of Magnesium and the amino acid arginine - all of them nourish the pituitary gland, enhancing the production of its hormone that control all the other glands. Wheatgrass is exceptionally high in B vitamins - vitamin B2, B6, B1, B5 and some amounts of vitamin B12. Vitamin B2 is very important for the production of the thyroid hormones. The B vitamins in general assist the body in energy production, making DNA, neutralising toxins, increasing serotonin and growth hormone, while controlling the steroid hormones like cortisol and adrenaline and removing excess estrogen and testosterone.

// \r\n
// GHEE
// \r\n
// Ghee or clarified butter works on the hormones by cleansing and nourishing the gut. Ghee is rich is butyric acid, which lines up the walls of the intestines, making the environment favorable to the gut flora. The gut microbiota is very closely connected to the brain, and increases serotonin and dopamine levels when thriving. Ghee also controls blood insulin levels by preventing quick absorption of sugars. With blood insulin levels in check, all the hormones also come under control.

// \r\n

// TIP: Have a tablespoon of warm ghee daily with your meals.

// COCONUT WATER
// \r\n
// Coconut water is dissolved with the healing minerals that nourish the hormones back to balance. Just a cup of coconut water has Magnesium, Manganese, Selenium and good amounts of Zinc. While Manganese and Magnesium boost the pituitary glands, Selenium and Zinc work wonders for the thyroid glands, boosting their performance. The activation of thyroid glands also stabilises the adrenal glands and the sex hormones. Coconut water is also rich in Potassium. This mineral is vital for the regulation of heart beats and maintenance of blood flow and blood pressure, which affects each and every cell in the body, including the glands and the immunity cells.

// \r\n

// TIP: 1 or 2 glasses of coconut water at any time, except right after meals, is soothing and healing to the entire system.

// ASH GOURD
// \r\n
// Ash gourd or winter melon or white pumpkin is 96% water. But, it is loaded with an array of vitamins and minerals. Ash gourd has Zinc, and good amounts of the important minerals like Calcium, Iron, Magnesium, Manganese and even sodium. Ash gourd is also highly alkaline. This is very important for the smooth flow of hormones. Estrogen relies heavily on Zinc and all the hormones rely on Magnesium, both of which are in abundance in ash gourd. Ash gourd is also rich in vitamins B1, B2, B3, B5 and B6. For the glands to function and produce hormones, we need B vitamins. Ash gourd has a high fibre content which cleanses the intestines and reduces the burden on the liver by making the process of detoxification more efficient. Therefore, the blood flow becomes smoother, making it easy for the hormones to flow and do their work.

// \r\n

// TIP: Blend the ash gourd along with water, squeeze a little lime and sprinkle some peppercorns. Have a glass of this juice daily morning on an empty stomach.

// HOLY BASIL
// \r\n
// Holy basil is a miracle medicinal herb. Its medicinal qualities come from its many antioxidant essential oils, like rosmarnic acid, eugenol, beta -sitosterol, oleanolic acid, isothymusin, etc. These essential oils make holy basil a powerful anti-inflammatory herb that soothes inflammation. It is also a great antimicrobial, reducing chances of infections in the body. Holy basil can balance cortisol levels. It also controls diabetes and lowers blood sugar and insulin levels. Additionally, it destroys free radicals in the body and increases the levels of serotonin and dopamine - the happy hormones our immune system thrives on.

// \r\n

// TIP: Boil a glass of water and steep 3-4 tulsi leaves in it. Drink the tea and chew on the leaves.

// METHI SEEDS
// \r\n
// Methi seeds or fenugreek seeds are concentrated in phytoestrogens or plant based compounds that act like estrogen in the body. These phytoestrogens reduce excessive estrogen, while increase estrogen levels if it is too low, like in women going through menopause. In fact, methi seeds reduce the symptoms of menopause. They also are rich in antioxidants called saponins which balance testosterone levels in the body. Methi seeds are also know to lower blood sugar and insulin levels as well as lower cholesterol levels, regulating the functioning of the entire endocrine system. They also have powerful anti-inflammatory properties that balance the immune system. Low Iron levels can lower thyroid hormones production. This means low energy to the entire body and a disruption of all the bodily functions. Just a tablespoon of methi seeds have large amount of Iron. It also has Copper (essential for red blood cell production), Zinc and Manganese which are crucial for thyroid gland functioning. Methi seeds are also rich in the amino-acids tyrosine and tryptophan, which boost dopamine as well as serotonin levels, reducing cortisol levels.

// \r\n

// TIP: Soak a teaspoon of Methi seeds in a cup of water overnight and have the water in the morning and chew on the seeds as well.

// http://127.0.0.1:8000
// http://13.233.84.192:9007
